// extracted by mini-css-extract-plugin
export default {"content":"Albums_content__oaGdr"};